// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1aySZ","disabled":"FileBtn_disabled__TK0H_","warn":"FileBtn_warn__FEarx","fade":"FileBtn_fade__3CRbm"};